
const GroupContainer = ({ children }) => (
  <div className="mb-8 px-8 pt-10">
    {children}
  </div>
)

export default GroupContainer;
